import React from "react";
import Approved from "./Approved";
import NewREQ from "./NewREQ";

const CustomerMain = ({ value }) => {
  return (
    <div>
      {value === 1 && <Approved />}
      {value === 2 && <NewREQ />}
    </div>
  );
};

export default CustomerMain;
